module.exports = __webpack_public_path__ + "img/cloud_tool_verticalbar.18af6eed.jpg";